window.loadCaptcha = function (fn){
    if(document.getElementById("hcaptchajs") !== undefined && document.getElementById("hcaptchajs") !== null){
        fn();
        return;
    }
    const tag = document.createElement('script');
    tag.id = "hcaptchajs";
    tag.src = "https://js.hcaptcha.com/1/api.js?render=explicit";
    tag.onload = () => fn()
    document.getElementsByTagName('body')[0].appendChild(tag);
}
